import { html } from 'lit';

export const arrowRightIcon = ({
  onClick,
  color = '#0099ff',
  height,
}: { onClick?: () => void; color?: string; height?: string } = {}) =>
  html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      @click=${() => onClick?.()}
      style=${`cursor: ${onClick ? 'pointer' : ''}; width: fit-content; height: ${height ?? '24px'}; fill: ${
        color ?? 'currentColor'
      };`}
    >
      <path
        d="M13.172 12L8.222 7.05c-0.391-0.391-0.391-1.024 0-1.414 0.391-0.391 1.024-0.391 1.414 0l5.657 5.657c0.391 0.391 0.391 1.024 0 1.414l-5.657 5.657c-0.391 0.391-1.024 0.391-1.414 0-0.391-0.391-0.391-1.024 0-1.414L13.172 12z"
      />
    </svg>
  `;
